import { AlertTriangle, Clock3, PackageX, ShieldAlert } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { DashboardAlert } from '@/api/reports';
import { cn } from '@/lib/utils';

const ICONS: Record<string, typeof PackageX> = {
  out: PackageX,
  low: AlertTriangle,
  expired: ShieldAlert,
  expiring: Clock3,
};

const TONE: Record<string, string> = {
  out: 'text-status-out bg-status-out/10',
  low: 'text-status-low bg-status-low/10',
  expired: 'text-status-expired bg-status-expired/10',
  expiring: 'text-status-expiring bg-status-expiring/10',
};

export function AlertsList({ alerts }: { alerts: DashboardAlert[] }) {
  if (alerts.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-muted-foreground">
        Nothing needs attention right now.
      </p>
    );
  }

  return (
    <ul className="divide-y divide-border">
      {alerts.slice(0, 8).map((alert, index) => {
        const Icon = ICONS[alert.type] ?? AlertTriangle;
        return (
          <li key={`${alert.medicineId}-${index}`}>
            <Link
              to={`/inventory?medicine=${alert.medicineId}`}
              className="flex items-center gap-3 py-2.5 text-sm font-medium transition-colors hover:text-primary"
            >
              <span className={cn('flex h-8 w-8 shrink-0 items-center justify-center rounded-xl', TONE[alert.type])}>
                <Icon className="h-3.5 w-3.5" />
              </span>
              <span className="min-w-0 flex-1 truncate">{alert.message}</span>
              <svg
                className="h-4 w-4 shrink-0 text-muted-foreground/40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </Link>
          </li>
        );
      })}
    </ul>
  );
}